import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw } from "lucide-react";

interface MaintenancePageProps {
  message?: string;
  onRetry?: () => void;
}

export const MaintenancePage: React.FC<MaintenancePageProps> = ({
  message = "O sistema está em manutenção. Tente novamente em alguns instantes.",
  onRetry,
}) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6">
          <div className="text-center space-y-4">
            {/* Icon */}
            <div className="flex justify-center">
              <div className="bg-yellow-100 p-4 rounded-full">
                <AlertTriangle className="h-8 w-8 text-yellow-600" />
              </div>
            </div>

            {/* Title */}
            <div className="space-y-2">
              <h1 className="text-2xl font-bold text-gray-900">
                Sistema em Manutenção
              </h1>
              <p className="text-gray-600 leading-relaxed">{message}</p>
            </div>

            {/* Retry Button */}
            {onRetry && (
              <Button onClick={onRetry} className="w-full" variant="outline">
                <RefreshCw className="h-4 w-4 mr-2" />
                Tentar Novamente
              </Button>
            )}

            {/* Additional Info */}
            <div className="text-sm text-gray-500 space-y-1">
              <p>Nossos engenheiros estão trabalhando para resolver isso.</p>
              <p>Por favor, tente novamente em alguns minutos.</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
